/**
 * @fileoverview Menu component.core#ca0f7c4d#ca0f7c4d#e00d894d#e00d894d#e00d894d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d#ff2ca74d
 *
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import '../../lib/mobiscroll/navigation.react';
// Config Import
import AppConfig from '../../AppConfig';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';
import { ENGINE_METHOD_NONE } from 'constants';

/**
 * メニューコンポーネント
 *
 * @class Menu
 * @extends {Component}
 */
class Menu extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'clickMenu');
  }

  /**
   * メニュークリック
   *
   * @param {Object} event event
   * @memberof Menu
   */
  clickMenu(event) {
    let dataset = event.target.dataset;
    // ボタン
    let url = event.target.id;
    // ハンバーガーメニューの場合
    if (!_.isEmpty(dataset.id)) {
      url = event.target.dataset.id;
    }
    // リンクの場合
    if (url.indexOf(AppConfig.httpScheme) !== -1) {
      window.location.href = url;
      return;
    }
    this.props.history.push(url);
  }

  /**
   * メニューの描画
   *
   * @returns {Object} ユーザー要素
   * @memberof Menu
   */
  renderServiceHistory() {
    return (
      <mobiscroll.Button
        theme={ConstUtil.Common.THEME}
        flat={true}
        onClick={this.clickMenu}
        id={ConstUtil.Common.COMPONENT.PACKAGE_LIST.URL}
        color="menubtn"
      >
        {ConstUtil.Message.PACKAGE_LIST.TITLE}
      </mobiscroll.Button>
    );
  }
  
  /**
   * 実績の描画
   *
   * @returns {Object} ユーザー要素
   * @memberof Menu
   */
  renderWorkspaceSchedule() {
    return (
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.JA}
          menuText={ConstUtil.Message.COMMON.PERFORMANCE + ConstUtil.Message.COMMON.MANAGEMENT}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          <mobiscroll.NavItem id={ConstUtil.Common.COMPONENT.RESULT_LIST.URL}>
            {ConstUtil.Message.RESULT_LIST.TITLE}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem id={ConstUtil.Common.COMPONENT.MEASURE_LIST.URL}>
            {ConstUtil.Message.MEASURE_LIST.TITLE}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
    );
  }
  /**
   * 入構一覧の描画
   *
   * @returns {Object} 管理要素
   * @memberof Menu
   */
  renderManagement() {
    return (
      <mobiscroll.Button
        flat={true}
        onClick={this.clickMenu}
        id={ConstUtil.Common.COMPONENT.ENTRYCAR_LIST.URL}
        color="menubtn"
      >
        {ConstUtil.Message.COMMON.ENTRY_LIST}
      </mobiscroll.Button>
    );
  }
  /**
   * 車両管理の描画
   *
   * @returns {Object} 管理要素
   * @memberof Menu
   */
  renderCarManagement() {
    return (
      <mobiscroll.Button
        flat={true}
        onClick={this.clickMenu}
        id={ConstUtil.Common.COMPONENT.CAR_LIST.URL}
        color="menubtn"
      >
        {ConstUtil.Message.COMMON.CARMANAGEMENT}
      </mobiscroll.Button>
    );
  }

  /**
   * メニュー要素の描画
   *
   * @returns {Object} メニュー要素
   * @memberof Menu
   */
  renderMenu() {
    let authorityId = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID
    );
    // 未ログイン状態の場合renderTotal
    if (_.isEmpty(authorityId)) {
      return <div />;
    }
    if (window.location.hash === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      return <div />;
    }
    return (
      <div className="menu-area">
        {this.renderServiceHistory()}
        {this.renderManagement()}
        {this.renderWorkspaceSchedule()}
        {this.renderCarManagement()}
      </div>
    );
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof Menu
   */
  render() {
    return <div className="menu-area">{this.renderMenu()}</div>;
  }
}

Menu.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func })
};
export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/js/component/core/Menu.jsx